import { Weapon } from './weapon';
import { ColumnModel, IColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializable } from 'starbase-launcher';
import { PrimaryWeapon } from './primaryWeapon';

export class WeaponLinking implements Serializable<WeaponLinking> {
  public uid: number;
  public weaponModelId: number;
  public imageModelId: number;
  /**Required link to the weapon record */
  public weapon: Weapon;
  /**Required link to the Weapon_Category */
  public primaryWeapon: PrimaryWeapon;
  public secondaryWeapon: string;
  public weapon_Category: string;
  public editMode: boolean;
  public editable: boolean;

  public static WeaponLinkColumnData(primaryWeapons, secondaryWeapons): IColumnModel[] {
    return [
      new ColumnModel('Weapon Category', 'primaryWeapon', 'PrimaryWeapon', true, 'dropdown', false, false, 30, false, primaryWeapons, 'weapon_Category', null, null, null, null, true, null, true),
      new ColumnModel('Weapon', 'secondaryWeapon', 'SecondaryWeapon', true, 'dropdown', false, false, 30, false, secondaryWeapons, 'secondaryWeapon', null, null, null, null, true, null, null, true),
    ];
  }

  public static setupWeaponLinkCollection(collection: WeaponLinking[]): void {
    of(collection).pipe(
      map((w: WeaponLinking[]) =>
        w.map((k: WeaponLinking) => {
          k.weapon = new Weapon().deserialize(k.weapon);
          k = new WeaponLinking().deserialize(k);
        })
      )
    ).subscribe();
  }
  public deserialize(input) {
    return Object.assign(new WeaponLinking(), input);
  }
}
